import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare let gtag: any;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor() { }

  logEvent(payload: { eventName: string, params: { buttonName: string, pageName: string } }) {
    if (environment.production) {
      this.logGoogleAnalytics(payload);
    }
  }

  logGoogleAnalytics(payload: { eventName: string, params: { buttonName: string, pageName: string } }) {
    gtag('event', payload.eventName);
  }
}
